module.exports = __webpack_public_path__ + "static/img/5bg-13.ac93df9.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/5bg-13.png
// module id = 721
// module chunks = 1